import React from "react";
import Link from "@mui/material/Link";
import { Link as NavigationLink } from "react-router-dom";

const RouterLink = React.forwardRef(function RouterLink(props, ref) {
  return (
    <Link component={NavigationLink} underline="hover" {...props} ref={ref} />
  );
});
export default RouterLink;
